import { render, staticRenderFns } from "./ExpertBankAccountForm.vue?vue&type=template&id=78e9d60b&lang=pug&"
import script from "./ExpertBankAccountForm.vue?vue&type=script&lang=js&"
export * from "./ExpertBankAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
